let groundsCallBackIndex = 0;
export function _creatFun(callback) {
    const funName = '__grounds_' + Number(Math.floor(Math.random() * 10000000000)).toString(36) + groundsCallBackIndex++;
    window[funName] = function (args) {
        callback(args);
    };
    return funName;
}
